import { stopSubmit } from 'redux-form';
import {ResultCodeEnum, ResultCodeForCaptchaEnum, authAPI, securityAPI} from '../api/api.ts'

const SET_AUTH_UESER_DATA = 'it/auth/SET_AUTH_UESER_DATA';
const GET_CAPTCHA_URL_SUCCESS = 'it/auth/GET_CAPTCHA_URL_SUCCESS';

const initialState = {
    id: null as number | null,
    email: null as string | null,
    login: null as string | null,
    isAuth: false as boolean,
    captchaUrl: null as string | null,
}

export type initialStateType = typeof initialState

const authReducer = (state = initialState, action: any): initialStateType => {
    switch(action.type) {
        case SET_AUTH_UESER_DATA:
        case GET_CAPTCHA_URL_SUCCESS:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state;
    }
}

type setAuthUserDataTypePayload = {
    id: number | null
    email: string | null 
    login: string | null
    isAuth: boolean | null
}

type setAuthUserDataType = {
    type: typeof SET_AUTH_UESER_DATA
    payload: setAuthUserDataTypePayload
}
export const setAuthUserData = (id: number | null, email: string | null, login: string | null, isAuth: boolean): setAuthUserDataType => ({type: SET_AUTH_UESER_DATA, payload:{id, email, login, isAuth}});

type getCaptchaUrlSuccessType = {
    type: typeof GET_CAPTCHA_URL_SUCCESS
    payload: {captchaUrl: string}
}
export const getCaptchaUrlSuccess = (captchaUrl: string): getCaptchaUrlSuccessType =>  ({ type: GET_CAPTCHA_URL_SUCCESS, payload: {captchaUrl}});

export const getHeaderThunk = () => async (dispatch: any) => {
    let authMe = await authAPI.getHeader()
    
    if (authMe.resultCode === ResultCodeEnum.Success) {
        let { id, email, login } = authMe.data;
        dispatch(setAuthUserData(id, email, login, true));
    }
}

export const loginThunk = (email: string, password: string, rememberMe: boolean = false, captcha: string) => async (dispatch: any) => {
    let loginData = await authAPI.login(email, password, rememberMe, captcha);

    if (loginData.resultCode === ResultCodeEnum.Success) {
        dispatch(getHeaderThunk());
    } else {
        if(loginData.resultCode === ResultCodeForCaptchaEnum.CapchaIsRequired) {
            dispatch(getCaptchaUrl());
        }
        let message = loginData.messages.length > 0 ? loginData.messages[0] : "Some error"
        dispatch(stopSubmit('login', { _error: message }))
    }
}

export const logoutThunk = () => async (dispatch: any) => {
    let response = await authAPI.logout()

    if (response.data.resultCode === 0) {
        dispatch(setAuthUserData(null, null, null, false));
    }
}

export const getCaptchaUrl = () => async (dispatch: any) => {
    const response = await securityAPI.getSecurityAPI();
    const captchaUrl = response.data.url;
    dispatch(getCaptchaUrlSuccess(captchaUrl));
}


export default authReducer;